import { DataObject } from "../core/data/DataObject";
/**
 * SetTriggerParams.ts
 */
export class SetTriggerParams {
    constructor(roomName, gameInstanceId, triggerType, triggerValue) {
        this.roomName = roomName;
        this.gameInstanceId = gameInstanceId;
        this.triggerType = triggerType;
        this.triggerValue = triggerValue;
    }
    liquify() {
        return new DataObject(this);
    }
}
//# sourceMappingURL=SetTriggerParams.js.map